import {Tooltip} from 'antd';
import {memo, useRef, useState} from 'react';

type PropsType = {
    title: string;
    className: string;
};

export const OverflowTitle = memo(function OverflowTitleInner({title, className}: PropsType): JSX.Element {
    const spanRef = useRef<HTMLSpanElement | null>(null);
    const [tooltipTitle, setTooltipTitle] = useState<string | null>(null);

    function handleMouseEnter() {
        const spanElement = spanRef.current;

        setTooltipTitle(spanElement && spanElement.scrollWidth > spanElement.clientWidth ? title : null);
    }

    return (
        <Tooltip title={tooltipTitle}>
            <span className={className} onMouseEnter={handleMouseEnter} ref={spanRef}>
                {title}
            </span>
        </Tooltip>
    );
});
